export class ResponseModel{
    public data?: any;
    public message?: string;
    public status?: number;
}